import {
  GridSpg,
  isArrayNotEmpty,
  isInternalLink,
  iTxt,
  SecurityGuard,
  useRedirect,
} from "@duosoftbg/nacid-components";
import { Button } from "@mui/material";
import React from "react";
import styled from "styled-components";
import { getI18n } from "react-i18next";

const ExternalLinkText = styled.span`
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 10 10'%3E%3Cpath fill='%23159' d='M0 10V0h3v1H1v8h8V7h1v3H0z M9 1.7L4.3 6.4L3.6 5.7L8.3 1H5V0h3.7 H10v5H9V1.7z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right center;
  padding-right: 20px;
  background-size: 14px 14px;
`;

type CategoryItemProps = {
  link: any;
};

const CategoryTileLink = ({ link }: CategoryItemProps) => {
  const accessRoles = link.accessRoles;

  return (
    <>
      {link.active && (
        <SecurityGuard checkForRoles={accessRoles} doCheck={isArrayNotEmpty(accessRoles)} roleOperator={"or"}>
          <CategoryTileLinkBody link={link}></CategoryTileLinkBody>
        </SecurityGuard>
      )}
    </>
  );
};

export default CategoryTileLink;

const CategoryTileLinkBody = ({ link }: CategoryItemProps) => {
  const { redirectWithEvent } = useRedirect();
  const title = iTxt(getI18n().language, link?.name, link?.nameEn);
  const href = link.href;
  return (
    <GridSpg style={{ padding: 0 }} my={1} item xs={12} sm={6} md={4} lg={4}>
      <Button
        style={{ textAlign: "left", justifyContent: "flex-start", display: "inline-block" }}
        fullWidth
        onClick={redirectWithEvent(href)}
      >
        {!isInternalLink(href) && <ExternalLinkText>{title}</ExternalLinkText>}
        {isInternalLink(href) && <span>{title}</span>}
      </Button>
    </GridSpg>
  );
};
